import {
  queryOptions,
  useMutation,
  useQuery,
  useQueryClient,
} from '@tanstack/vue-query';
import { type AxiosError, type AxiosResponse } from 'axios';

import { axios } from '@/helpers/axios';

export function userPreferenceQueryOptions<T = unknown>(preference: string) {
  return queryOptions({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: ['account', 'user-preferences', preference],
    queryFn: async ({ signal }) => {
      const response = await axios.get<{
        preference_name: string
        preference_value: string
      }>(`account/user-preferences/${preference}`, {
        signal,
      });

      return JSON.parse(response.data.preference_value) as T;
    },
  });
}

export function useUserPreferenceQuery<T = unknown>(preference: string) {
  return useQuery(userPreferenceQueryOptions<T>(preference));
}

export function useUserPreferenceUpdateMutation(preference: string) {
  const queryClient = useQueryClient();

  return useMutation<AxiosResponse, AxiosError, unknown>({
    mutationFn: (data) => axios.post('account/user-preferences', {
      preference_name: preference,
      preference_value: JSON.stringify(data),
    }),
    onSuccess: () => {
      void queryClient.invalidateQueries(userPreferenceQueryOptions(preference));
    },
  });
}
